<template>
    <div id="files">
        <send-files-nimp class="mb-2" v-if="entity.TYPE == 'Job' && object.contact && object.contact.nuwall" :files="files" :job-id="object.id"></send-files-nimp>
        <v-chip-group v-if="tags.length > 0"
                      v-model="selectedTag"
                      class="tag-selector"
                      selected-class="text-primary">
            <v-chip v-for="tag in tags"
                    filter
                    :value="tag"
                    :key="tag"
                    :text="tag"></v-chip>
        </v-chip-group>
        <div v-bind="getRootProps()" class="vue-dropzone" :class="{'is-dropping':isDragActive}">
            <input v-bind="getInputProps()" />
            <p class="dz-message">Drop files here ...</p>
        </div>
        <v-skeleton-loader v-if="loading"
                           type="table">
        </v-skeleton-loader>
        <v-table v-if="!loading" density="compact" class="text-caption">
            <tbody>
                <tr>
                    <th class="w-40">File</th>
                    <th class="w-10">Created</th>
                    <th style="width:15%">By</th>
                    <th class="w-10 text-right"></th>
                </tr>
                <tr v-for="file in filteredFiles" :key="file.id">
                    <td><a href="javascript:void(0);" @click="openFile(file)">{{ file.fileName }}</a> <div v-if="file.tag"><small>{{ file.tag }}</small></div></td>
                    <td>{{ file.dateCreated }}</td>
                    <td>{{ file.createdByShort }}</td>
                    <td class="text-right">
                        <v-btn icon="mdi-trash-can-outline"
                               @click="showConfirmDelete(file)"
                               size="x-small"></v-btn>
                    </td>
                </tr>
            </tbody>
        </v-table>
        <v-dialog v-model="confirmDelete"
                  width="auto">
            <v-card>
                <v-card-text v-if="deleteFile">
                    Are you sure you want to delete this file?
                </v-card-text>
                <v-card-actions>
                    <v-btn :loading="deleting"
                           color="primary"
                           prepend-icon="mdi-trash-can-outline"
                           @click="confirmDeleteItem"
                           dark>
                        DELETE
                    </v-btn>
                    <v-btn dark @click="confirmDelete = false" :disabled="deleting">
                        CANCEL
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>
<style scoped>
    .vue-dropzone {
        border-radius: 0.25rem;
        background: rgba(0,0,0,.03);
        border: 1px solid rgba(0,0,0,.03);
        padding:20px 20px;
        min-height:80px;
    }
    .is-dropping {
        background: #BBDEFB;
        border: #1E88E5;
    }
    .dz-message {
        text-align: center;
        margin: 2em 0;
        cursor: pointer;
    }
</style>
<script>
    import { useDropzone } from "vue3-dropzone";
    import { mapActions, mapState } from "vuex";
    import { getCurrentInstance, ref } from "vue";
    import { api as viewerApi } from "v-viewer"
    export default {
        name: "FilesPanel",
        data: function () {
            return {
                loading: false,
                files: [],
                deleteFile: null,
                confirmDelete: false,
                deleting: false,
                selectedTag: null,
            }
        },
        setup() {
            const { proxy } = getCurrentInstance();
            function onDrop(acceptFiles, rejectReasons) {
                const formData = new FormData(); // pass data as a form
                for (var x = 0; x < acceptFiles.length; x++) {
                    formData.append("Files[]", acceptFiles[x]);
                }
                formData.append('Type', '0');
                formData.append('SaveName', 'Upload');
                formData.append('FileName', 'Upload');
                if (proxy.entity.TYPE == "Job") {
                    formData.append('JobId', proxy.object.id);
                }
                if (proxy.selectedTag) {
                    formData.append('Tag', proxy.selectedTag);
                }
                proxy.$api.post("/systemfiles/", formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }).then((response) => {
                    proxy.showSuccessSnack(acceptFiles.length > 1 ? "Files uploaded" : "File uploaded");
                    proxy.loadFiles();
                    if (proxy.entity.TYPE == "Job" && proxy.selectedTag == proxy.$constants.files.TAG_WARRANTY) {
                        proxy.reloadEntities();
                    }
                }).catch((err) => {
                proxy.showErrorSnack("There was an error uploading the file");
            });
    }
    const { getRootProps, getInputProps, ...rest } = useDropzone({ onDrop });
    return {
        getRootProps,
        getInputProps,
        ...rest,
    };
        },
    props: {
        object: Object,
            entity: Object,
                tag: String
    },
    mounted: function () {
        this.loading = true;
        if (typeof this.tag !== 'undefined' && this.tag) {
            this.selectedTag = this.tag;
        }
        this.loadFiles();
    },
    methods: {
            ...mapActions([
        "showErrorSnack",
        "showSuccessSnack",
        "reloadEntities"
    ]),
    openFile(file) {
            var imageIndex = this.getImages.findIndex((image) => {
                return image.id == file.id;
            });
            if (imageIndex > -1) {
                const $viewer = viewerApi({
                    options: {
                        toolbar: false,
                        url: 'src',
                        initialViewIndex: imageIndex
                    },
                    images: this.getImages
                });
            } else {
                window.open(file.fileLink, '_blank').focus();
            }
            return false;
        },
        loadFiles() {
            let route = 'SystemFiles/?';
            if (this.entity.TYPE == "Job") {
                route += "jobId=" + this.object.id;
            }
            if (this.entity.TYPE == "WarehouseTransaction") {
                route += "warehouseTransactionId=" + this.object.id;
            }
            this.$api.get(route)
                .then(res => {
                    this.loading = false;
                    this.files = res.data;
                }).catch(error => {
                    this.showErrorSnack("There was an issue getting the files.")
                });
        },
        showConfirmDelete(file) {
            this.deleteFile = file;
            this.confirmDelete = true;
        },
        confirmDeleteItem() {
            this.deleting = true;
            this.$api.delete('SystemFiles/' + this.deleteFile.id)
                .then(res => {
                    const index = this.files.findIndex(obj => obj.id === this.deleteFile.id);
                    this.files.splice(index, 1);
                    this.confirmDelete = false;
                    this.deleteFile = null;
                    this.deleting = false;
                    this.showSuccessSnack("Removed!");
                }).catch(error => {
                    this.deleting = false;
                    this.showErrorSnack("Whoops. We ran into an error.");
                });
        },
    },
    computed: {
        ...mapState({
            user: (state) => state.auth.user,
        }),
        filteredFiles() {
            if (this.selectedTag) {
                let filter = this.selectedTag;
                return this.files.filter(function (item) {
                    return item.tag == filter;
                });
            }
            return this.files;
        },
        getImages() {
            if (this.files) {
                return this.files.filter(function (item) {
                    var extension = item.saveName.split('.').pop().toLowerCase();
                    return ['png', 'jpeg', 'jpg', 'gif', 'tiff', 'tif', 'bmp'].includes(extension);
                }).map(function (item) {
                    return { src: item.fileLink, id: item.id };
                });
            }
            return [];
        },
        tags() {
            if (this.entity.TYPE == "Job") {
                return this.$constants.files.tags;
            }
            return [];
        }
    }
    };
</script>